import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { Airline } from '@app/entities/airline';
import { fetchAirlinesSuccessAction } from '@app/store/actions/global.actions';

export interface AirlinesState extends EntityState<Airline> {}

function getId(airline: Airline): string {
  return airline.code;
}

export const airlinesAdapter: EntityAdapter<Airline> = createEntityAdapter<Airline>({
  selectId: getId
});

export const initialState: AirlinesState = airlinesAdapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(fetchAirlinesSuccessAction, (state, { airlines }) => {
    return airlinesAdapter.setAll(airlines.map(mapAirline).filter(airline => !!airline && !!airline.code), state);
  })
);

function mapAirline(airline: string): Airline {
  const splitAirline = airline.split('(');
  const code = splitAirline[1].replace(')', '');
  return {
    name: splitAirline[0],
    code: code
  };
}

export function airlinesReducer(state: AirlinesState, action: Action): AirlinesState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = airlinesAdapter.getSelectors();
